import type { DeepString } from "@/lib/i18n";

export const pl = {
  apply: "Aplikuj",
  sendCv: "Wyślij CV",
} as const;

export type WDedicatedJobOffersTranslations = DeepString<typeof pl>;
